/* eslint-disable max-len */
import { getListSong,
  addSubmissionSong,
  getListGenreSong,
  getDetailSubmission,
  addSubmitSubmissionProcess,
  addSubmitSubmissionPublish,
  addSubmitSubmissionUnpublish,
  countSubmissionContent,
  editSubmissionSong,
  updateAlbumOnly,
  deleteSubmission,
  getListSongByArtist,
  addSong,
  editSong,
  getTags,
  saveTags,
  addSongFileTemp,
  uploadLyrics
} from '@/services/song';

const getters = {
  listSong: state => state.listSong,
  listSongArtist: state => state.listSongArtist,
  getPercentageUpload: state => state.percentCompleted,
  listGenreSong: state => state.listGenreSong,
  countWaitingForReview: state => state.countWaitingForReview,
  countUnderReview: state => state.countUnderReview,
  countApproved: state => state.countApproved,
  countRejected: state => state.countRejected,
  countPublished: state => state.countPublished,
  countWaitingForReviewByArtist: state => state.countWaitingForReviewByArtist,
  countUnderReviewByArtist: state => state.countUnderReviewByArtist,
  countApprovedByArtist: state => state.countApprovedByArtist,
  countRejectedByArtist: state => state.countRejectedByArtist,
  countPublishedByArtist: state => state.countPublishedByArtist,
};

const actions = {
  async requestListSong({ commit, dispatch, rootGetters }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const isArtist = rootGetters['AuthModule/isArtist'];
      const filterList = filter.status === 4 ? { ...filter, status: 2, published: 1 } : { ...filter, published: 0 };
      const result = await getListSong(filterList, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, !isArtist);
      dispatch('requestStatusSubmission');
      commit('SET_LIST_FREE_SONG', result.data);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestAddSubmissionFreeSong({ commit, dispatch, rootGetters }, song) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      // TODO : call service api to add submission free song
      commit('SET_PERCENTAGE_UPLOAD', 0);
      await addSubmissionSong(song, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, (event) => {
        const percentCompleted = Math.round((100 * event.loaded) / event.total);
        commit('SET_PERCENTAGE_UPLOAD', percentCompleted);
      });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'error-add-song' }, { root: true });
      throw err;
    } finally {
      commit('NotificationModule/SET_STATUS', { status: 200, message: 'Success', errorCode: null }, { root: true });
      commit('SET_PERCENTAGE_UPLOAD', 0);
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestAddSong({ commit, dispatch, rootGetters }, song) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      commit('SET_PERCENTAGE_UPLOAD', 0);
      await addSong(song, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, (event) => {
        const percentCompleted = Math.round((100 * event.loaded) / event.total);
        commit('SET_PERCENTAGE_UPLOAD', percentCompleted);
      });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'error-add-song' }, { root: true });
      throw err;
    } finally {
      commit('NotificationModule/SET_STATUS', { status: 200, message: 'Success', errorCode: null }, { root: true });
      commit('SET_PERCENTAGE_UPLOAD', 0);
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestEditSong({ commit, dispatch, rootGetters }, song) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      commit('SET_PERCENTAGE_UPLOAD', 0);
      await editSong(song, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, (event) => {
        const percentCompleted = Math.round((100 * event.loaded) / event.total);
        commit('SET_PERCENTAGE_UPLOAD', percentCompleted);
      });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'error-update-song' }, { root: true });
      throw err;
    } finally {
      commit('NotificationModule/SET_STATUS', { status: 200, message: 'Success', errorCode: null }, { root: true });
      commit('SET_PERCENTAGE_UPLOAD', 0);
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestUpdateSubmissionSong({ commit, dispatch, rootGetters }, song) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      commit('SET_PERCENTAGE_UPLOAD', 0);
      await editSubmissionSong(song, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'error-update-song' }, { root: true });
      throw err;
    } finally {
      commit('SET_PERCENTAGE_UPLOAD', 0);
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestUpdateAlbumOnly({ commit, dispatch, rootGetters }, { song, filter }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      // TODO : call service api to add submission free song
      await updateAlbumOnly(song, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      dispatch('requestListSong', filter);
      dispatch('requestStatusSubmission');
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
      throw err;
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestListGenreSong({ commit, rootGetters }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      // TODO : call service api to get list Song
      const result = await getListGenreSong({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      commit('SET_LIST_GENRE_SONG', result.data);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestDetailSubmission({ commit, rootGetters }, idSubmission) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const isArtist = rootGetters['AuthModule/isArtist'];
      const result = await getDetailSubmission(idSubmission, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, !isArtist);
      return result.data;
      // commit('SET_DETAIL_SUBMISSION_FREE_SONG', result.data);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return null;
  },
  async requestSubmitSubmissionProcess({ commit, dispatch, rootGetters }, { submissionData, filter }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      // TODO : call service api to add submission free song
      await addSubmitSubmissionProcess(submissionData, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      dispatch('requestListSong', filter);
      dispatch('requestStatusSubmission');
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
      throw err;
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestSubmitSubmissionPublish({ commit, dispatch, rootGetters }, { submissionData, filter }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      // TODO : call service api to add submission free song
      await addSubmitSubmissionPublish(submissionData, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      dispatch('requestListSong', filter);
      dispatch('requestStatusSubmission');
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
      throw err;
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestSubmitSubmissionUnpublish({ commit, dispatch, rootGetters }, { submissionData, filter }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      // TODO : call service api to add submission free song
      await addSubmitSubmissionUnpublish(submissionData, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      dispatch('requestListSong', filter);
      dispatch('requestStatusSubmission');
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
      throw err;
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },

  async requestStatusSubmission({ commit, rootGetters }) {
    try {
      const countWaitingForReview = await countSubmissionContent(0, null, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      const countUnderReview = await countSubmissionContent(1, null, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      const countApproved = await countSubmissionContent(2, 0, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      const countRejected = await countSubmissionContent(3, null, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      const countPublished = await countSubmissionContent(2, 1, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      commit('UPDATE_COUNT_STATUS', { countWaitingForReview, countUnderReview, countApproved, countRejected, countPublished });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
      throw err;
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestStatusSubmissionByArtist({ commit, rootGetters }, data) {
    try {
      const countWaitingForReview = await countSubmissionContent(0, null, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, data.id);
      const countUnderReview = await countSubmissionContent(1, null, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, data.id);
      const countApproved = await countSubmissionContent(2, 0, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, data.id);
      const countRejected = await countSubmissionContent(3, null, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, data.id);
      const countPublished = await countSubmissionContent(2, 1, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, data.id);
      commit('UPDATE_COUNT_STATUS_BY_ARTIST', { countWaitingForReview, countUnderReview, countApproved, countRejected, countPublished });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
      throw err;
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestDeleteSubmission({ commit, dispatch, rootGetters }, { submissionData, filter }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const isArtist = rootGetters['AuthModule/isArtist'];
      await deleteSubmission(submissionData, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, !isArtist);
      dispatch('requestListSong', filter);
      dispatch('requestStatusSubmission');
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
      throw err;
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  // ARTIST
  async requestListSongByArtist({ commit, dispatch, rootGetters }, { filter, data }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const filterList = filter.status === 4 ? { ...filter, status: 2, published: 1 } : { ...filter, published: 0 };
      const result = await getListSongByArtist(filterList, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, data.id);
      dispatch('requestStatusSubmissionByArtist', data);
      commit('SET_LIST_SONG_ARTIST', result.data);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestGetTags({ rootGetters }, filter) {
    let response = [];
    try {
      const result = await getTags(filter, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      response = result.data;
    } catch (err) {

    }
    return response;
  },
  async requestSaveTags({ commit, dispatch, rootGetters }, { data, filter }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await saveTags(data, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      dispatch('requestListSong', filter);
      dispatch('requestStatusSubmission');
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
      throw err;
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestAddSongFileTemp({ commit, dispatch, rootGetters }, { file, callback = (event) => {} }) {
    let response = null;
    try {
      response = await addSongFileTemp(file, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, (event) => {
        callback(event);
      });
      commit('NotificationModule/SET_STATUS', { status: 200, message: 'Success', errorCode: null }, { root: true });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
      throw err;
    } finally {
      commit('NotificationModule/TOGGLE_LOADING_WITH_MESSAGE', { toggle: false, message: 'please wait...' }, { root: true });
    }
    return response;
  },
  async requestUploadLyrics({ commit, dispatch, rootGetters }, data) {
    let response = null;
    try {
      response = await uploadLyrics(data, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      commit('NotificationModule/SET_STATUS', { status: 200, message: 'Success', errorCode: null }, { root: true });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
      throw err;
    } finally {
      commit('NotificationModule/TOGGLE_LOADING_WITH_MESSAGE', { toggle: false, message: 'please wait...' }, { root: true });
    }
    return response;
  },
};

const mutations = {
  SET_LIST_FREE_SONG(state, listSong) {
    state.listSong = listSong;
  },
  SET_PERCENTAGE_UPLOAD(state, percentage) {
    state.percentCompleted = percentage;
  },
  SET_LIST_GENRE_SONG(state, listGenre) {
    state.listGenreSong = listGenre;
  },
  SET_DETAIL_SUBMISSION_FREE_SONG(state, song) {
    state.detailSubmissionFreeSong = song;
  },
  UPDATE_COUNT_STATUS(state, { countWaitingForReview, countUnderReview, countApproved, countRejected, countPublished = 0 }) {
    state.countWaitingForReview = countWaitingForReview.data.total;
    state.countUnderReview = countUnderReview.data.total;
    state.countApproved = countApproved.data.total;
    state.countRejected = countRejected.data.total;
    state.countPublished = countPublished.data.total;
  },
  UPDATE_COUNT_STATUS_BY_ARTIST(state, { countWaitingForReview, countUnderReview, countApproved, countRejected, countPublished }) {
    state.countWaitingForReviewByArtist = countWaitingForReview.data.total;
    state.countUnderReviewByArtist = countUnderReview.data.total;
    state.countApprovedByArtist = countApproved.data.total;
    state.countRejectedByArtist = countRejected.data.total;
    state.countPublishedByArtist = countPublished.data.total;
  },
  SET_LIST_SONG_ARTIST(state, listSong) {
    state.listSongArtist = listSong;
  },
};

export default {
  namespaced: true,
  state: {
    listSong: {},
    listSongArtist: {},
    listGenreSong: [],
    percentCompleted: 0,
    detailSubmissionFreeSong: {},
    countWaitingForReview: 0,
    countUnderReview: 0,
    countApproved: 0,
    countRejected: 0,
    countPublished: 0,
    countWaitingForReviewByArtist: 0,
    countUnderReviewByArtist: 0,
    countApprovedByArtist: 0,
    countRejectedByArtist: 0,
    countPublishedByArtist: 0,
  },
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/stores/Song/index.js